import { FormControl, Stack, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { MonitorUrlFieldInput } from 'components/status-checks/form/status-check/common/MonitorUrlFieldInput'
import TestStatusCheck from 'components/status-checks/form/status-check/common/TestStatusCheck'
import { useAwsMonitorUrlFieldOnChangeHandler } from 'components/status-checks/hooks/use-aws-monitor-url-field-onchange-handler'
import {
  buildTeamExternalIntegration,
  type StatusCheckFormValues
} from 'components/status-checks/status-checks-form-utils'
import { useStatusCheckDetailsContext } from 'context/status-checks/StatusCheckDetailsContext'

const fieldsToWatch = [
  'externalIntegration',
  'evaluationConfiguration'
] as const

export const AWSMonitorURL = () => {
  const { control, getValues } = useFormContext<StatusCheckFormValues>()
  const [externalIntegration, evaluationConfiguration] = useWatch({
    control,
    name: fieldsToWatch
  })

  const handleMonitorUrlFieldChange = useAwsMonitorUrlFieldOnChangeHandler()
  const { handleSuccess, isTestStatusCheckDisabled } =
    useStatusCheckDetailsContext()

  return (
    <FormControl component={Stack} sx={{ rowGap: 1 }}>
      <Typography>
        What monitor or alert will help Gremlin determine the health of your
        Service?
      </Typography>
      <Controller
        control={control}
        name="monitorUrl"
        render={({ field, fieldState }) => (
          <MonitorUrlFieldInput
            externalIntegration={externalIntegration}
            field={field}
            fieldState={fieldState}
            label="Monitor or Alert URL"
            onChange={handleMonitorUrlFieldChange(field)}
          />
        )}
      />
      <TestStatusCheck
        disabled={isTestStatusCheckDisabled}
        evaluationConfiguration={evaluationConfiguration}
        integration={buildTeamExternalIntegration(getValues())}
        onSuccess={handleSuccess}
      />
    </FormControl>
  )
}
